import React, { useState } from "react"
import Dropdown from "../DropDown"
import moment from 'jalali-moment';
import { toast } from "react-toastify";

export const date = () => {
  const day = [];
  const month = [
    { id: 1, title: "فروردین" },
    { id: 2, title: "اردیبهشت" },
    { id: 3, title: "خرداد" },
    { id: 4, title: "تیر" },
    { id: 5, title: "مرداد" },
    { id: 6, title: "شهریور" },
    { id: 7, title: "مهر" },
    { id: 8, title: "آبان" },
    { id: 9, title: "آذر" },
    { id: 10, title: "دی" },
    { id: 11, title: "بهمن" },
    { id: 12, title: "اسفند" },
  ];
  const year = [];

  const thisYear = Number(moment(new Date().toLocaleString("en-US")).locale("fa").format("jYYYY"));

  for (let i = 0; i < 31; i++) {
    day.push({ id: i + 1, title: i + 1 })
  }
  for (let i = thisYear; i > thisYear - 150; i--) {
    year.push({ id: i, title: i })
  }

  return { day, month, year };
}

export default ({ show, toggleShow, onSubmit, value = "" }) => {
  const prevDate = value?.split("/");
  const prevDay = prevDate && date().day.find(e => e.id === +prevDate[2])
  const prevMonth = prevDate && date().month.find(e => e.id === +prevDate[1])
  const prevYear = prevDate && date().year.find(e => e.id === +prevDate[0])
  const [day, setDay] = useState(prevDay || {})
  const [month, setMonth] = useState(prevMonth || {})
  const [year, setYear] = useState(prevYear || {})

  return (
    show ? <div className={`modal flexed fl-c full`}>
      <div className={`p-45 bg-top-nav w-40 shadow-mild radius-8 popIn`}>
        <h3 className="m-0 text-shadow font-16 px-8">افزودن تاریخ تولد</h3>
        <hr className="mb-0" />
        <form action="" onSubmit={(e) => {
          e.preventDefault();
          const date = `${year.title}/${month.id}/${day.title}`;
          if (moment(date, "jYYYY/jMM/jDD").isValid()) {
            onSubmit(date)
            toggleShow(false)
          } else {
            toast("تاریخ نا معتبر است", { type: "error" })
          }
        }}>
          <div className="px-32 pt-24 pb-16 modal-content" style={{ overflow: "visible" }}>
            <div className="grid" style={{ gridTemplateColumns: '2fr 2fr 2fr', gap: 16 }}>
              <Dropdown items={date().day} selectedItem={day} onItemClick={(e) => setDay(e)} name="روز" />
              <Dropdown items={date().month} selectedItem={month} onItemClick={(e) => setMonth(e)} name="ماه" />
              <Dropdown items={date().year} selectedItem={year} onItemClick={(e) => setYear(e)} name="سال" />
            </div>
          </div>
          <div className="ltr mt-32 px-8">
            <button className="bd-none bg-tomato iran-sans radius-4 font-10 text-top-nav"
              style={{ width: 85, padding: '5px 0' }}>ثبت</button>
            <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav ml-16"
              onClick={() => toggleShow(false)}
              style={{ color: '#ffb1ccbb', padding: '5px 0', width: 85, border: '1px solid #ffb1ccbb' }}
              type="button">بازگشت</button>
          </div>
        </form>
      </div>
    </div> : <div></div>
  )
}
